import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield, Award, Trophy, ChevronRight, Crosshair, Flag, Handshake } from "lucide-react";
import { LOGO_ALLIES } from "@/lib/api";
import { IMG } from "@/lib/assets";
import api from "@/lib/api";

const VALUES = [
  { icon: Handshake, t: "Rispetto", d: "Rispetto reciproco fra tutti i membri e le entità." },
  { icon: Shield, t: "Collaborazione", d: "Sana collaborazione per un beneficio comune." },
  { icon: Crosshair, t: "Competizione", d: "Sano spirito competitivo fra amici" },
  { icon: Award, t: "Onore", d: "Vincere con rispetto, dentro e fuori dal campo." },
];

export default function SealsAlliesForce() {
  const [next, setNext] = useState(null);
  useEffect(() => { api.get("/public/tournaments").then(({ data }) => setNext(data.active[0] || data.upcoming[0] || null)).catch(() => {}); }, []);

  return (
    <div className="text-white">
      {/* HERO */}
      <section className="relative min-h-[92vh] flex items-center overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundImage: `url(${IMG.militaryBg})`, backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-[#0b1a34]/70 to-[#050507]" />
        <div className="absolute inset-0 grid-overlay-gold opacity-50" />
        <div className="relative max-w-7xl mx-auto px-5 grid md:grid-cols-2 gap-10 items-center py-16">
          <div className="flex justify-center order-2 md:order-1">
            <img src={LOGO_ALLIES} alt="Seals Allies Force" className="w-72 sm:w-96 object-contain floaty drop-shadow-[0_0_50px_rgba(201,162,39,0.5)]" data-testid="allies-hero-logo" />
          </div>
          <div className="fade-up order-1 md:order-2">
            <span className="inline-flex items-center gap-2 font-rajdhani uppercase tracking-[0.3em] text-[var(--gold-light)] text-xs border border-[var(--gold)]/50 px-3 py-1 clip-beveled-sm mb-6"><Flag className="w-3 h-3" /> Elite Forces Alliance</span>
            <h1 className="heading text-5xl sm:text-7xl lg:text-8xl leading-none">SEALS<br /><span className="gold-text">ALLIES FORCE</span></h1>
            <p className="heading text-2xl tracking-[0.25em] text-gray-200 mt-4">RISPETTO · COLLABORAZIONE · VANTAGGI COMUNI</p>
            <p className="font-rajdhani text-gray-300 mt-5 max-w-lg text-lg">S.A.F. Nasce dalla volontà di offrire ai membri del reggimento Seals un'esperienza di gioco diversa dall'ordinario.</p>
            <div className="flex flex-wrap gap-4 mt-8">
              <a href="#alleanza" className="btn-gold clip-beveled px-8 py-3">Scopri l'Alleanza</a>
              <Link to="/tornei" className="btn-outline-gold clip-beveled px-8 py-3">Scopri i Tornei</Link>
            </div>
          </div>
        </div>
      </section>

      {/* COS'È */}
      <section id="alleanza" className="max-w-7xl mx-auto px-5 py-20">
        <div className="text-center mb-14">
          <h2 className="heading text-5xl gold-text">COS'È L'ALLEANZA</h2>
          <div className="star-divider max-w-xs mx-auto mt-4"><span className="text-[var(--gold)]">★</span><span className="text-[var(--gold)]">★</span></div>
        </div>
        <p className="font-rajdhani text-gray-300 text-lg text-center max-w-3xl mx-auto">
          S.A.F. Nasce dalla volontà di offrire ai membri del reggimento Seals un'esperienza di gioco diversa dall'ordinario. I Seals, a guida della S.A.F., garantiscono eperienza e capacità organizzative/gestionali nell'organizzazione di eventi in Call of Duty: Warzone. Per far parte di S.A.F. è fondamentale condividerne i valori di: rispetto reciproco e sana collaborazione fra entità indipendenti che cooperano per un beneficio comune.
        </p>
      </section>

      {/* VALORI */}
      <section className="max-w-7xl mx-auto px-5 py-20">
        <h2 className="heading text-4xl sm:text-5xl gold-text text-center mb-12">I NOSTRI VALORI</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {VALUES.map((v, i) => (
            <div key={i} className="panel clip-beveled p-6 text-center hover:panel-gold transition-colors fade-up" style={{ animationDelay: `${i * 0.06}s` }}>
              <v.icon className="w-9 h-9 text-[var(--gold)] mx-auto mb-3" strokeWidth={1.5} />
              <h3 className="heading text-2xl text-white">{v.t}</h3>
              <p className="font-rajdhani text-gray-400 text-xs mt-1">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* EVENTI */}
      <section className="relative py-20 border-y border-white/10">
        <div className="absolute inset-0 grid-overlay-gold opacity-30" />
        <div className="relative max-w-4xl mx-auto px-5 text-center" data-testid="saf-eventi">
          <Trophy className="w-10 h-10 text-[var(--gold)] mx-auto mb-4" strokeWidth={1.5} />
          <h2 className="heading text-4xl sm:text-5xl gold-text">EVENTI</h2>
          <div className="star-divider max-w-xs mx-auto mt-4"><span className="text-[var(--gold)]">★</span><span className="text-[var(--gold)]">★</span></div>
          <p className="font-rajdhani text-gray-300 text-lg mt-6">Teniamo molto al fatto che organizziamo diversi tipi di eventi, che possano offrire un'esperienza di gioco positiva per tutta la community affiliata S.A.F.</p>
        </div>
      </section>

      {/* TORNEI CTA */}
      <section className="max-w-7xl mx-auto px-5 pb-20">
        <div className="panel panel-gold clip-beveled p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6" data-testid="allies-next-tournament">
          <div>
            <span className="font-rajdhani uppercase tracking-[0.3em] text-[var(--gold-light)] text-xs">{next?.state === "in_progress" ? "Torneo in corso" : "Prossimo torneo"}</span>
            <h2 className="heading text-4xl sm:text-5xl gold-text mt-2">{next ? next.name : "Nuovi tornei in arrivo"}</h2>
            <p className="font-rajdhani text-gray-400 mt-1">{next ? `${next.mode} · ${next.map}` : "Preparati alla prossima operazione."}</p>
          </div>
          <Link to="/tornei" className="btn-gold clip-beveled px-8 py-3 flex items-center gap-2 shrink-0">Vedi Tutti i Tornei <ChevronRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </div>
  );
}
